var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractPostTask from '../abstract-post-task';
import Exception from '../../exception/exception';
export default class ResetPasswordTask extends AbstractPostTask {
    constructor() {
        super(...arguments);
        this.token = '';
        this.password = '';
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute();
            if (response.status === this.successCode) {
                return;
            }
            switch (response.status) {
                default:
                    throw new Error(Exception.UnknownError);
            }
        });
    }
    get url() {
        return '/authentication/password';
    }
    get authenticated() {
        return false;
    }
    get successCode() {
        return 200;
    }
    get data() {
        return {
            token: this.token,
            password: this.password,
        };
    }
}
//# sourceMappingURL=reset-password-task.js.map